var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDomicilio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.852,
    height: 25.543,
    viewBox: "0 0 38.852 25.543",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__x0023_Layer_x0020_1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2843108759184"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_491",
    "data-name": "Grupo 491"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_161",
    "data-name": "Trazado 161",
    d: "M36.671,10.987h-.755L32.96,5.819A2.132,2.132,0,0,0,31.113,4.7H26.48V2.407A2.3,2.3,0,0,0,24.3,0H7.469a2.3,2.3,0,0,0-2.18,2.407V4.7H.779A.824.824,0,0,0,0,5.56a.823.823,0,0,0,.779.859H10.871a.823.823,0,0,0,.779-.859.824.824,0,0,0-.779-.862H6.847V2.407a.656.656,0,0,1,.622-.685H24.3a.656.656,0,0,1,.622.685V20.249H15.6a4.154,4.154,0,0,0-3.946-3.573A4.154,4.154,0,0,0,7.7,20.249H7.469a.655.655,0,0,1-.622-.682V14.791h4.024a.865.865,0,0,0,0-1.722H.779a.865.865,0,0,0,0,1.722H5.289v4.776a2.3,2.3,0,0,0,2.18,2.4H7.7a4.151,4.151,0,0,0,3.946,3.573A4.151,4.151,0,0,0,15.6,21.971H27.94a4.151,4.151,0,0,0,3.946,3.573,4.151,4.151,0,0,0,3.946-3.573h.838a2.3,2.3,0,0,0,2.18-2.4V13.39a2.3,2.3,0,0,0-2.18-2.4ZM11.651,23.692h0a2.474,2.474,0,0,1-2.341-2.581,2.472,2.472,0,0,1,2.341-2.581,2.47,2.47,0,0,1,2.341,2.581A2.472,2.472,0,0,1,11.651,23.692ZM26.48,6.419h4.633a.608.608,0,0,1,.526.32l2.434,4.248H26.48Zm5.406,17.273h0a2.472,2.472,0,0,1-2.341-2.581,2.352,2.352,0,1,1,4.682,0A2.474,2.474,0,0,1,31.887,23.692Zm5.406-4.125h0a.657.657,0,0,1-.622.682h-.838a4.154,4.154,0,0,0-3.946-3.573,4.154,4.154,0,0,0-3.946,3.573H26.48V12.705H36.671a.658.658,0,0,1,.622.685Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_162",
    "data-name": "Trazado 162",
    d: "M11.667,4.328a.823.823,0,0,0,.779-.859.824.824,0,0,0-.779-.862H1.575A.824.824,0,0,0,.8,3.468a.823.823,0,0,0,.779.859Z",
    transform: "translate(1.666 6.278)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomicilio);
export default __webpack_public_path__ + "static/media/domicilio.28dd73516bb857ba4dae75cb402e936e.svg";
export { ForwardRef as ReactComponent };